export const FeatureToggle = {
  PatientRecords: 'wellz.cp.web.ft.patient_records',
  CareMatrixProfile: 'wellz.cp.web.ft.care_matrix',
  CareMatrixModule: 'wellz.cp.web.ft.care_matrix_module',
  NewLoginFlow: 'wellz.accounts.new_login_flow',
  AgendaCareMatrixModule: 'wellz.cp.web.ft.agenda_care_matrix_module',
  MeetPage: 'wellz.cp.web.ft.meet_page',
  RecordTab: 'wellz.cp.web.ft.care_matrix_module.record_tab',
  PhoneNumber: 'wellz.cp.web.ft.patient.phone_number',
  SuggestedMessages: 'wellz.cp.web.suggested_messages',
  SuggestedMessagesV1: 'wellz.cp.web.suggested_messages_v1',
  ForwardAlertV2: 'wellz.cp.web.forward_alert_v2',
  PatientSubscriptionStatus: 'wellz.cp.web.ft.patient.subscription_status',
  Invite: 'wellz.cp.web.ft.invite',
  Reschedule: 'wellz.cp.web.ft.reschedule',
  MinimumInviteTime: 'wellz.cp.web.ft.minimum_invite_time',
} as const;
